export const types = {
  UPDATE_CUSTOMER_INFO: 'UPDATE_CUSTOMER_INFO',
}
